(function () {
  const SNIPPET = 'ruk_rating_snippet_collection';
  const skuCache = new Map();

  let ensureToken = 0;

  function runInitSnippets() {
    if (typeof ratingSnippet !== 'function') return false;

    ratingSnippet(SNIPPET, {
      store: 'titanav-co',
      color: window.reviewsIoCardRatingColor,
      linebreak: false,
      text: ''
    });
    return true;
  }

  function ensureSnippetsInit() {
    if (runInitSnippets()) return;

    const token = ++ensureToken;
    let attempts = 0;

    function retry() {
      if (token !== ensureToken) return;
      if (runInitSnippets()) return;
      if (++attempts >= 50) return;
      setTimeout(retry, 200);
    }

    setTimeout(retry, 200);
  }

  function itemHandle(item) {
    if (item.handle) return item.handle;
    const part = item.url && item.url.split('/products/')[1];
    return part ? part.split('?')[0] : '';
  }

  async function getReviewsSku(handle) {
    if (!handle) return null;
    if (skuCache.has(handle)) return skuCache.get(handle);

    try {
      const res = await fetch('/products/' + handle + '.js');
      if (!res.ok) return null;

      const product = await res.json();
      const sku = product.variants.map(function (v) { return v.sku; }).filter(Boolean).join(';')
        + ';' + product.variants.map(function (v) { return v.id; }).join(';');

      skuCache.set(handle, sku);
      return sku;
    } catch (err) {
      return null;
    }
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  async function waitForCartLines(cartRoot, minCount) {
    for (let attempt = 0; attempt < 8; attempt += 1) {
      const lines = cartRoot.querySelectorAll('.amp-cart__cart-line');
      if (lines.length >= minCount) return lines;
      await wait(75);
    }

    return cartRoot.querySelectorAll('.amp-cart__cart-line');
  }

  function findCartLineForItem(lines, item, index, usedLines) {
    if (lines[index] && !usedLines.has(lines[index])) {
      return lines[index];
    }

    const handle = itemHandle(item);
    if (!handle) return null;

    for (let i = 0; i < lines.length; i += 1) {
      const line = lines[i];
      if (usedLines.has(line)) continue;

      const link = line.querySelector('a[href*="/products/"]');
      if (!link) continue;

      const href = link.getAttribute('href') || link.href || '';
      if (href.indexOf('/products/' + handle) !== -1) return line;
    }

    return null;
  }

  function lineHasReview(line) {
    return line.querySelector('.titan-amp-cart-review, .' + SNIPPET);
  }

  function clearAmpCartReviews(cartRoot) {
    cartRoot.querySelectorAll(
      '.titan-amp-cart-review, .amp-cart__cart-line .' + SNIPPET
    ).forEach(function (el) {
      el.remove();
    });
  }

  function injectReviewOnLine(line, sku) {
    if (lineHasReview(line)) return false;

    const rating = document.createElement('div');
    rating.className = SNIPPET + ' titan-amp-cart-review';
    rating.dataset.sku = sku;

    const title = line.querySelector('.amp-cart__cart-line-title');
    (title || line).after(rating);
    return true;
  }

  let ampReviewToken = 0;

  window.titanInjectAmpCartReviews = async function (cart) {
    if (!window.TitanAmpCart?.showReviews || !cart?.items?.length) return;

    const cartRoot = document.querySelector('.amp-cart');
    if (!cartRoot) return;

    const token = ++ampReviewToken;
    clearAmpCartReviews(cartRoot);

    const lines = await waitForCartLines(cartRoot, cart.items.length);
    if (token !== ampReviewToken) return;

    const usedLines = new Set();
    let added = false;

    for (let i = 0; i < cart.items.length; i += 1) {
      const item = cart.items[i];
      const handle = itemHandle(item);
      let line = findCartLineForItem(lines, item, i, usedLines);

      if (!handle || !line) continue;

      const sku = await getReviewsSku(handle);
      if (token !== ampReviewToken) return;
      if (!sku) continue;

      if (!cartRoot.contains(line)) {
        const refreshedLines = cartRoot.querySelectorAll('.amp-cart__cart-line');
        line = findCartLineForItem(refreshedLines, item, i, usedLines);
        if (!line) continue;
      }

      if (injectReviewOnLine(line, sku)) {
        usedLines.add(line);
        added = true;
      }
    }

    if (added) requestAnimationFrame(ensureSnippetsInit);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureSnippetsInit);
  } else {
    ensureSnippetsInit();
  }

  document.addEventListener('on:facet-filters:updated', ensureSnippetsInit);
})();
